// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bottom-panel-item[data-v-265b512c]{display:inline-block;font-size:33px;line-height:30px;cursor:pointer;margin-right:25px}\n", ""]);
// Exports
module.exports = exports;
